

     const body = document.querySelector('body');
    document.addEventListener('DOMContentLoaded', function() {
        if (sessionStorage.getItem('is_shown') !== 'true') {
            body.classList.add('splash-loaded');
            sessionStorage.setItem('is_shown','true');     

        }
          else {
            body.classList.remove('splash-loaded');
          }       
    });




